import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../../facturotopia';

class NominaPercepcionesSeparacionIndemnizacionForm extends Component {
  state = {
    data: {}
  }

  rules = {}

  constructor(props) {
    super(props);

    this.rules = props.rules;
  }

  componentDidMount() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data }
      });
    }
  }

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (values) => {
    const data = {
      ...this.props.data,
      ...values
    };

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes()
    });
  }

  render() {
    const rules = this.rules;
    const { data = {} } = this.props;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Total Pagado"
              name="TotalPagado"
              placeholder=""
              help=""
              min="0"
              rules={ rules.TotalPagado }
              value={ data.TotalPagado }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Número Años Servicio"
              name="NumAñosServicio"
              placeholder=""
              help=""
              min="1"
              max="99"
              rules={ rules.NumAñosServicio }
              value={ data.NumAñosServicio }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Último Sueldo Mensual Ordinario"
              name="UltimoSueldoMensOrd"
              placeholder=""
              help=""
              min="0"
              rules={ rules.UltimoSueldoMensOrd }
              value={ data.UltimoSueldoMensOrd }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Ingreso Acumulable"
              name="IngresoAcumulable"
              placeholder=""
              help=""
              min="0"
              rules={ rules.IngresoAcumulable }
              value={ data.IngresoAcumulable }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Ingreso No Acumulable"
              name="IngresoNoAcumulable"
              placeholder=""
              help=""
              min="0"
              rules={ rules.IngresoNoAcumulable }
              value={ data.IngresoNoAcumulable }
              onChange={ this.handleOnChange }
            />
          </Col>

        </Row>

        <Row>
          <Col>
            <div className="text-muted">
              Cuando selecciones una percepción con las siguientes claves es necesario que especifiques los detalles de Separación Indemnización.

              <ul>
                <li>“022” Prima por Antigüedad</li>
                <li>“023” Pagos por separación</li>
                <li>“025” Indemnizaciones</li>
              </ul>
            </div>
          </Col>
        </Row>

      </>
    )
  }
}

export default NominaPercepcionesSeparacionIndemnizacionForm;